import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

export const DEFAULT_SETTINGS = {
  phone: "0734 641446",
  mobiles: "Marcello 335 6889860 · Daniele 335 1308892 · Marco 335 1308893",
  email: "lattanzicostruzioni@gmail.com",
  address: "Contrada Alberelli, 20 — Fermo (FM)",
  piva: "01763110440",
  instagram: "https://www.instagram.com/lattanzicostruzioni/",
};

const Ctx = createContext({ settings: DEFAULT_SETTINGS, reload: () => {} });

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const reload = () =>
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {});
  useEffect(() => {
    reload();
  }, []);
  return <Ctx.Provider value={{ settings, reload }}>{children}</Ctx.Provider>;
}

export const useSettings = () => useContext(Ctx);
